import { useEffect } from "react";
import { useAuth } from "zudoku/components";
import { FullScreen } from "./FullScreen";
import { isPublicRoute } from "./publicRoutes";

let loginStarted = false;

// Mounted in the `layout-before-head` slot. While a visitor has no session on
// a protected route it shows a splash instead of the page, and sends them to
// Keycloak once Zudoku has finished checking for an existing session.
export const AuthGate = ({
  location,
}: {
  location: { pathname: string; search: string };
}) => {
  const auth = useAuth();
  const needsLogin = !isPublicRoute(location.pathname) && !auth.isAuthenticated;
  const startLogin = needsLogin && !auth.isPending;

  useEffect(() => {
    if (!startLogin || loginStarted) return;
    loginStarted = true;
    void auth
      .login({ redirectTo: location.pathname + location.search })
      .catch(() => {
        loginStarted = false;
      });
  }, [startLogin, auth, location.pathname, location.search]);

  if (!needsLogin) return null;

  return (
    <FullScreen>
      <div
        role="status"
        aria-label="Checking sign-in"
        className="h-6 w-6 animate-spin rounded-full border-2 border-muted-foreground border-t-transparent"
      />
      <p className="text-muted-foreground">Checking your sign-in…</p>
    </FullScreen>
  );
};
